import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "ion-text-center ion-padding-bottom" }
const _hoisted_2 = { class: "ion-padding-bottom" }
const _hoisted_3 = { class: "ion-padding-bottom" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", {
  class: "ion-margin-top",
  style: {"border-bottom":"1px solid var(--ion-color-medium)"}
}, null, -1)
const _hoisted_5 = { style: {"width":"fit-content"} }
const _hoisted_6 = { class: "ion-text-center" }

import {
  CustomElement,
  EditableState,
  Grade,
  GradeProps,
  SingleGradesParameters,
  Language,
  Colors,
  GeneralSubElements,
  User,
  GeneralTableCardElements,
  OrderedCardsList,
} from "@/types";
import {
  executeLink,
  getAviableLanguages,
  getCurrentElement,
  getCustomMessage,
  getIcon,
  getLocale,
  checkGradeParameters,
  hasGradeTypingErrors,
} from "@/utils";
import {
  IonHeader,
  IonToolbar,
  IonGrid,
  IonRow,
  IonCol,
  IonText,
  IonLabel,
  IonInput,
  IonCheckbox,
  IonButton,
  IonTextarea,
  IonDatetime,
  IonDatetimeButton,
  IonModal,
  DatetimeCustomEvent,
  IonItem,
  IonContent,
} from "@ionic/vue";
import { PropType, reactive, Ref, ref, watch } from "vue";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'GradesManager',
  props: {
  title: {
    type: String,
    required: true,
  },
  parameters: {
    type: Object as PropType<SingleGradesParameters>,
    required: true,
  },
  grades: Array<Grade>,
},
  emits: ["signal_event", "close"],
  async setup(__props) {

let __temp: any, __restore: any

const props = __props;

const changeData = (event: DatetimeCustomEvent) => {
  const tmp_str_date = event.target.value;

  let tmp_date: Date;

  if (typeof tmp_str_date == "string") {
    tmp_date = new Date(tmp_str_date);
    if (tmp_date <= end_of_day) {
      date = tmp_date;
    } else {
      date = undefined;
    }
  } else {
    date = undefined;
  }
};
const setGradesTable = async (empty = true) => {
  let tmp_mean = 0;

  actual_final_grade_index = props.parameters.final_grade_index ?? -1;
  if (empty) {
    setupEditMode(true);
  }
  table_data.cards[""] = [];
  if (props.grades != undefined) {
    actual_grades = props.grades;
  } else {
    actual_grades = await executeLink(
      "/v1/students/" +
        props.parameters.student_id +
        "/grades?course_id=" +
        props.parameters.course_id +
        "&session_id=" +
        props.parameters.session_id +
        (props.parameters.teacher_id != undefined
          ? "&teacher_id=" + props.parameters.teacher_id
          : ""),
      (response) => response.data.data.map((a: GradeProps) => new Grade(a)),
      () => []
    );
  }

  for (const grade_index in actual_grades) {
    final_grade_pubblication =
      actual_final_grade_index != -1 &&
      actual_grades[actual_final_grade_index] != undefined
        ? actual_grades[actual_final_grade_index].publication
        : actual_grades[grade_index].final
        ? actual_grades[grade_index].publication
        : undefined;

    table_data.cards[""].push(
      user.type == "teacher"
        ? actual_grades[grade_index].toTableCard(
            props.parameters.associated_teacher ?? false,
            user.id,
            props.parameters.student_id,
            final_grade_pubblication,
            props.parameters.show_editable
          )
        : actual_grades[grade_index].toTableCard()
    );

    if (!actual_grades[grade_index].final) {
      tmp_mean += actual_grades[grade_index].grade;
    } else {
      actual_final_grade_index = parseInt(grade_index);
    }
  }

  if (actual_grades.length > 1) {
    mean = (
      tmp_mean /
      (actual_grades.length - (actual_final_grade_index != -1 ? 1 : 0))
    ).toFixed(2);
  } else if (actual_grades.length == 1 && actual_final_grade_index == -1) {
    mean = actual_grades[0].grade.toFixed(2);
  } else {
    mean = "-";
  }

  if (
    user.type == "teacher" &&
    props.parameters.associated_teacher === false &&
    (actual_final_grade_index == -1 ||
      (actual_grades[actual_final_grade_index] != undefined &&
        actual_grades[actual_final_grade_index].getEditableStatus(
          final_grade_pubblication
        ) != EditableState.AFTER_7_DAYS))
  ) {
    column_sizes = ["6", "2", "2", "1", "1"];
    first_row = base_row.concat(
      {
        id: "edit",
        type: "string",
        content: "",
      },
      {
        id: "remove",
        type: "string",
        content: "",
      }
    );
  } else {
    column_sizes = ["6", "3", "3"];
  }
};
const setupEditMode = (empty = false) => {
  to_edit =
    actual_grades[
      actual_grades.findIndex((a) => a.id == store.state.event.data.id)
    ];
  for (const description of Object.keys(descriptions)) {
    descriptions[description as keyof typeof descriptions] = empty
      ? ""
      : to_edit[description];
  }
  date_value = empty ? undefined : to_edit.publication.toISOString();
  grade.value = "" + (empty ? "" : to_edit.grade);
  final.value = empty ? false : to_edit.final;
  edit_trigger.value++;
  edit_mode = empty ? false : true;
};

const store = useStore();
const languages = getAviableLanguages();
const user = User.getLoggedUser() as User;




const elements: {
  [key: string]: CustomElement;
} = {
  close: {
    id: "close",
    type: "icon",
    linkType: "event",
    content: {
      event: "close",
      icon: getIcon("close"),
    },
  },
  title: {
    id: "title",
    type: "title",
    content: props.title,
  },
};
const base_row: CustomElement[] = [
  {
    id: "description",
    type: "string",
    content: getCurrentElement("description"),
  },
  {
    id: "date",
    type: "string",
    content: getCurrentElement("date"),
  },
  {
    id: "evaluation",
    type: "string",
    content: getCurrentElement("evaluation"),
  },
];
const descriptions: {
  [key in keyof Language as `${Language}_description`]: string;
} = reactive({
  italian_description: "",
  english_description: "",
});
const grade: Ref<string> = ref("");
const final: Ref<boolean> = ref(false);
const colors: Colors<GeneralSubElements> = {
  text: {
    name: "primary",
    type: "var",
  },
};
const edit_trigger = ref(0);
const table_data: OrderedCardsList<GeneralTableCardElements> = {
  order: [],
  cards: {
    "": [],
  },
};
const end_of_day = new Date();
end_of_day.setHours(23, 59, 59, 999);

let first_row: CustomElement[] = base_row;
let mean = "";
let date: Date | undefined = undefined;
let actual_grades: Grade[] = [];
let actual_final_grade_index: number;
let column_sizes: string[];
let final_grade_pubblication: Date | undefined;
let edit_mode = false;
let date_value: string | undefined;
let to_edit: Grade;

;(
  ([__temp,__restore] = _withAsyncContext(() => setGradesTable())),
  await __temp,
  __restore()
);
watch(
  () => store.state.triggers.grades,
  () => {
    setGradesTable(); //<!-- TODO (5): guardare se fa richieste per niente quando viene eliminato un voto o simile (dato che ha già la roba sistemata), valutando ache aggiornamenti da altri professori (cosa simile in project class)
  }
);
watch(
  () => store.state.triggers.edit_grades,
  () => {
    setGradesTable(true);
  }
);

return (_ctx: any,_cache: any) => {
  const _component_ionic_element = _resolveComponent("ionic-element")!
  const _component_ionic_table = _resolveComponent("ionic-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonModal), { "keep-contents-mounted": true }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_unref(IonDatetime), {
          key: edit_trigger.value,
          id: "datetime",
          onIonChange: changeData,
          "first-day-of-week": 1,
          max: _unref(end_of_day).toISOString(),
          "hour-cycle": "h23",
          locale: _unref(getLocale)(),
          "show-clear-button": true,
          "clear-text": _unref(getCurrentElement)('clear'),
          value: _unref(date_value)
        }, null, 8, ["max", "locale", "clear-text", "value"]))
      ]),
      _: 1
    }),
    _createVNode(_unref(IonHeader), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonToolbar), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonGrid), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonRow), { class: "ion-text-center ion-align-items-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonCol), null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ionic_element, {
                          element: elements.title
                        }, null, 8, ["element"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonCol), { size: "auto" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ionic_element, {
                          element: elements.close,
                          onSignal_event: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
                        }, null, 8, ["element"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(IonContent), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonGrid), { class: "ion-no-margin" }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonRow), null, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_unref(IonCol), {
                  key: 
            _unref(actual_final_grade_index) !== -1
              ? edit_trigger.value + '_grades'
              : undefined
          ,
                  size: "12",
                  "size-md": 
            (__props.parameters.teacher_id != undefined &&
              table_data.cards[''].length != 0 &&
              _unref(actual_final_grade_index) === -1) ||
            _unref(edit_mode)
              ? '7'
              : '12'
          
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_component_ionic_table, {
                      key: _unref(store).state.triggers.grades,
                      emptiness_message: 
              _unref(getCustomMessage)(
                'emptiness_message',
                _unref(getCurrentElement)('no_grades'),
                'string',
                colors,
                {
                  label: {
                    align_text_middle: true,
                    'ion-padding-bottom': true,
                  },
                }
              )
            ,
                      data: table_data,
                      first_row: _unref(first_row),
                      sizes: _unref(column_sizes),
                      onSignal_event: _cache[1] || (_cache[1] = 
              () => {
                if (_unref(store).state.event.event == 'edit_grade') {
                  setupEditMode();
                } else {
                  _ctx.$emit('signal_event');
                }
              }
            )
                    }, null, 8, ["emptiness_message", "first_row", "sizes"])),
                    _createElementVNode("div", _hoisted_1, [
                      _createVNode(_unref(IonText), null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(getCurrentElement)("intermediate_arithmetic_mean")) + _toDisplayString(_unref(actual_final_grade_index) != -1
                  ? " (" +
                    _unref(getCurrentElement)("no_final_grade").toLowerCase() +
                    ")"
                  : "") + ": " + _toDisplayString(_unref(mean)), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }, 8, ["size-md"])),
                (
            (__props.parameters.teacher_id != undefined &&
              __props.parameters.associated_teacher === false &&
              _unref(actual_final_grade_index) === -1) ||
            _unref(edit_mode)
          )
                  ? (_openBlock(), _createBlock(_unref(IonCol), {
                      key: edit_trigger.value + '_parameters',
                      size: "12",
                      "size-md": table_data.cards[''].length == 0 ? '12' : '5'
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                          _createElementVNode("div", _hoisted_3, [
                            _createVNode(_component_ionic_element, {
                              element: 
                  _unref(getCustomMessage)(
                    'description',
                    _unref(getCurrentElement)(
                      'grade_' + (_unref(edit_mode) ? 'edit' : 'insertion')
                    ),
                    'title',
                    colors
                  )
                
                            }, null, 8, ["element"])
                          ]),
                          _createElementVNode("div", null, [
                            _createVNode(_component_ionic_element, {
                              element: 
                  _unref(getCustomMessage)(
                    'description',
                    _unref(getCurrentElement)('description'),
                    'string',
                    colors
                  )
                
                            }, null, 8, ["element"]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(languages), (language) => {
                              return (_openBlock(), _createBlock(_unref(IonTextarea), {
                                key: language,
                                "auto-grow": true,
                                modelValue: descriptions[`${language}_description`],
                                "onUpdate:modelValue": ($event: any) => ((descriptions[`${language}_description`]) = $event),
                                label: _unref(getCurrentElement)(language),
                                "aria-label": _unref(getCurrentElement)(language),
                                fill: "outline",
                                class: "ion-margin-vertical"
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "aria-label"]))
                            }), 128))
                          ]),
                          _hoisted_4,
                          _createElementVNode("div", null, [
                            _createVNode(_unref(IonItem), {
                              style: {"width":"fit-content"},
                              lines: "none"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonLabel), {
                                  "aria-label": _unref(getCurrentElement)('date'),
                                  color: "primary",
                                  style: {"color":"var(--ion-color-primary)"}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(getCurrentElement)("date")), 1)
                                  ]),
                                  _: 1
                                }, 8, ["aria-label"]),
                                _createVNode(_unref(IonDatetimeButton), {
                                  datetime: "datetime",
                                  style: {"width":"fit-content"},
                                  class: "ion-padding-start"
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(IonInput), {
                              type: "number",
                              modelValue: grade.value,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((grade).value = $event)),
                              label: _unref(getCurrentElement)('grade'),
                              "aria-label": _unref(getCurrentElement)('grade'),
                              color: "black",
                              style: {"color":"var(--ion-color-primary)"},
                              fill: "outline",
                              class: "ion-margin-vertical",
                              onIonInput: _cache[3] || (_cache[3] = 
                  () => {
                    if (_unref(hasGradeTypingErrors)('ion-input', grade.value)) {
                      grade.value = grade.value.substring(0, grade.value.length - 1);
                    }
                  }
                ),
                              onKeydown: _cache[4] || (_cache[4] = 
                  ($event) => {
                    if (_unref(hasGradeTypingErrors)('keydown', grade.value, $event.key)) {
                      $event.preventDefault();
                    }
                  }
                )
                            }, null, 8, ["modelValue", "label", "aria-label"]),
                            _createElementVNode("div", _hoisted_5, [
                              _createVNode(_unref(IonLabel), {
                                position: "floating",
                                "aria-label": _unref(getCurrentElement)('final_grade'),
                                color: "primary",
                                style: {"color":"var(--ion-color-primary)"},
                                class: "ion-padding-horizontal"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(getCurrentElement)("final_grade")), 1)
                                ]),
                                _: 1
                              }, 8, ["aria-label"]),
                              _createVNode(_unref(IonCheckbox), {
                                disabled: _unref(edit_mode),
                                modelValue: final.value,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((final).value = $event)),
                                "aria-label": _unref(getCurrentElement)('final_grade')
                              }, null, 8, ["disabled", "modelValue", "aria-label"])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                          (_unref(edit_mode))
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createVNode(_unref(IonButton), {
                                  onClick: _cache[6] || (_cache[6] = () => {
                  let actual_grade = _unref(checkGradeParameters)(descriptions, _unref(date), grade.value);
                  let grade_props;
    
                  if (actual_grade != undefined) {
                    grade_props = {
                      id: _unref(store).state.event.data.id,
                      publication: _unref(date) != undefined ? _unref(date).toISOString() : (_unref(date_value) ?? _unref(to_edit).publication.toISOString()),
                      italian_description: '',
                      english_description: '',
                      grade: actual_grade,
                      final: final.value ? 1 : 0,
                    };
                    _unref(languages).forEach(a => grade_props[`${a}_description`] = descriptions[`${a}_description`]);
                    _unref(store).state.event.data.new_grade = new _unref(Grade)(grade_props);
                  }
                  _ctx.$emit('signal_event');
                })
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(getCurrentElement)("edit")), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(IonButton), {
                                  onClick: _cache[7] || (_cache[7] = ($event: any) => (setupEditMode(true)))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(getCurrentElement)("cancel")), 1)
                                  ]),
                                  _: 1
                                })
                              ], 64))
                            : (_openBlock(), _createBlock(_unref(IonButton), {
                                key: 1,
                                onClick: _cache[8] || (_cache[8] = 
                () => {
                  let actual_grade = _unref(checkGradeParameters)(
                    descriptions,
                    _unref(date),
                    grade.value
                  );

                  if (actual_grade != undefined) {
                    _unref(store).state.event = {
                      event: 'add_grade',
                      data: {
                        ...__props.parameters,
                        ...descriptions,
                        publication_date:
                          _unref(date) != undefined ? _unref(date).toISOString() : undefined,
                        grade: actual_grade,
                        final: final.value,
                      },
                      method: 'post',
                    };
                    _ctx.$emit('signal_event');
                    _ctx.$emit('close');
                  } else {
                    _ctx.$emit('signal_event');
                  }
                }
              )
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(getCurrentElement)("insert_grade")), 1)
                                ]),
                                _: 1
                              }))
                        ])
                      ]),
                      _: 1
                    }, 8, ["size-md"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})